window.Sparkle = window.Sparkle || {};

if (!window.Sparkle.I18n) {
  class SparkleI18n {
    /**
     * @param {Object} data - [Required] A nested object of translations.
     * @example
     *
     * const i18n = new SparkleI18n({
     *   "hello": "Hello, world!"
     * });
     */
    constructor(data) {
      this.backend = this.#normalizeData(data);
    }

    /**
     * Merge data into the backend. Performs a deep merge to combine nested keys.
     *
     * @param {Object} data
     * @returns {SparkleI18n} - The instance
     */
    merge(data) {
      jQuery.extend(true, this.backend, this.#normalizeData(data));

      return this;
    }

    /**
     * Alias for translate.
     *
     * @see translate
     */
    t(...args) {
      return this.translate(...args);
    }

    /**
     * Translate a key.
     * If the key is not found, it will return a string with the key and the error message.
     *
     * @param {string} key - A dot-separated key.
     * @returns {string|Object} - The translation or an object with the key and the error message.
     *
     * @example
     *
     * const i18n = new SparkleI18n({
     *   "hello": {
     *     "world": "Hello, world!"
     *   }
     * });
     *
     * i18n.translate("hello"); // { "hello": "Hello, world!" }
     * i18n.translate("hello.world"); // "Hello, world!"
     * i18n.translate("hello.world.foo"); // "Translation missing: hello.world.foo"
     */
    translate(key) {
      const path = key.split(".");

      let translation;
      try {
        translation = path.reduce((currentNode, currentKey) => currentNode[currentKey], this.backend);
      } catch (error) {
        console.error(`Error translating ${key}:`, error);
      }

      if (translation != null) {
        // console.debug('translated', key, 'to', translation);
      } else {
        translation = `Translation missing:, ${key}`;
        console.error(translation);
      }

      return translation;
    }

    // Accept a Sparkle.I18n object or regular nested hashes
    #normalizeData(data) {
      if (data instanceof SparkleI18n) {
        data = data.backend;
      }

      return { ...data };
    }
  }

  window.Sparkle.I18n = SparkleI18n;
}
